// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const exploud: PokeData = {
  "id": 295,
  "name": "exploud",
  "height": 15,
  "weight": 840,
  "base_experience": 221,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "stomp",
    "bite",
    "roar",
    "supersonic",
    "hyper-beam",
    "screech",
    "rest",
    "sleep-talk",
    "crunch",
    "uproar",
    "hyper-voice",
    "astonish",
    "howl",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "synchronoise",
    "echoed-voice",
    "boomburst"
  ],
  "moves": [
    "bite",
    "supersonic",
    "crunch",
    "hyper-voice",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "quick-attack",
    "purification",
    "tri-attack",
    "protect",
    "leer",
    "growl"
  ],
  "evolution_chain": {
    "id": 145,
    "item": null,
    "species": [
      {
        "name": "whismur",
        "order": 319,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "loudred",
        "order": 320,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 293,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "exploud",
        "order": 321,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 294,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 140,
    "speed": 111,
    "ability_power": 149
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
